import { defineComponent } from 'vue';
import axios from 'axios';
export default defineComponent({
  name: 'Microsite Override Journey',
  data() {
    return {
      banner: {},
      articles: []
    };
  },
  created() {
    this.getArticles();
  },
  methods: {
    async getArticles() {
      const {
        data
      } = await axios.get(`${process.env.VUE_APP_MS_CMS_PATH}/news/micro-site/override`);
      if (data) this.articles = data;
      return this.articles;
    }
  }
});